export default "__VITE_ASSET__644519c8__"